/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Items_EmptyInputs */

const vi_pl_items_empty = /** @type {(inputs: Pl_Items_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có dòng lô.`)
};

/**

* @param {Pl_Items_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_items_empty = /** @type {((inputs?: Pl_Items_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Items_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_items_empty(inputs)
});